import React, { useState } from 'react';
import { Button, Drawer, Table } from 'antd';
import { ImportWorker } from '@scheduling/graphql/mutations/workers-import';
import Text from 'antd/lib/typography/Text';
import { OrganizationUnitType } from '@institutions/graphql';

const renderUnit = (unit: OrganizationUnitType) => (
  <>
    <Text>{unit.name}</Text>
    <br />
    <Text type="secondary">{unit.costCenter}</Text>
  </>
);

const AllowedUnitsDrawer = ({
  allowedUnits,
  onClose,
  open,
}: {
  allowedUnits: OrganizationUnitType[];
  onClose: () => void;
  open: boolean;
}) => {
  return (
    <Drawer title="Units" open={open} onClose={onClose}>
      <Table
        showHeader={false}
        pagination={false}
        columns={[
          {
            key: 'name',
            title: 'Name',
            dataIndex: 'name',
            render: (_: string, record: OrganizationUnitType) =>
              renderUnit(record),
          },
        ]}
        dataSource={allowedUnits}
      />
    </Drawer>
  );
};

type Props = {
  importWorkers: ImportWorker[];
};

export function WorkerUploadReviewTable({ importWorkers }: Props) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [allowedUnits, setAllowedUnits] = useState<OrganizationUnitType[]>([]);

  const columns = [
    {
      key: 'name',
      title: 'Name',
      render: (_: string, record: ImportWorker) => {
        return `${record.firstName} ${record.lastName}`;
      },
    },
    {
      key: 'eeid',
      title: 'EEID',
      dataIndex: 'employeeId',
    },
    {
      key: 'email',
      title: 'Email',
      dataIndex: 'email',
    },
    {
      key: 'phoneNumber',
      title: 'Phone Number',
      dataIndex: 'phoneNumber',
    },
    {
      key: 'role',
      title: 'Role',
      dataIndex: ['role', 'abbreviation'],
    },
    {
      key: 'workforceGroup',
      title: 'Group',
      dataIndex: ['workforceGroup', 'name'],
    },
    {
      key: 'ftePercentage',
      title: 'FTE %',
      dataIndex: 'ftePercentage',
      render: (value: number | null) => (value !== null ? `${value}%` : ''),
    },
    {
      key: 'homeUnit',
      title: 'Home Unit',
      dataIndex: 'homeUnit',
      render: renderUnit,
    },
    {
      key: 'allowedUnits',
      title: '# Units',
      render: (_: string, record: ImportWorker) => (
        <>
          <Button
            type="link"
            onClick={() => {
              setAllowedUnits(record.otherUnits);
              setDrawerOpen(true);
            }}
          >
            {record.otherUnits.length}
          </Button>
        </>
      ),
    },
  ];

  const pagination = {
    pageSize: 50,
  };

  return (
    <>
      <AllowedUnitsDrawer
        allowedUnits={allowedUnits}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
      <Table
        className="wk-members-add-multiple-review__table"
        columns={columns}
        dataSource={importWorkers}
        pagination={pagination}
      />
      <style jsx>{`
        :global(.wk-members-add-multiple-review__table .ant-table) {
          padding: 12px;
        }
        :global(
          .wk-members-add-multiple-review__table .ant-table-tbody > tr > td
        ) {
          padding: 12px 4px 12px 8px;
        }
      `}</style>
    </>
  );
}
